import React from "react";
import styled from "styled-components";

import Card from "./card";

import mappingNamaPartai from "../mappings/nama-partai.json";

const PartaiCircle = styled(Card)`
    width: 2.5em;
    height: 2.5em;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 0.25em;
    box-sizing: border-box;
    img {
        width: 100%;
        /* margin: 0.5em auto; */
    }
`;

const PartaiLogo = ({ nama, className }) => (
    <PartaiCircle className={className}>
        <img src={require(`../assets/partai/${nama}.png`)} alt={mappingNamaPartai[nama]} title={mappingNamaPartai[nama]} />
    </PartaiCircle>
)

export default PartaiLogo;